<template>
  <div class="p-4">
    <h1 class="font-bold text-2xl">Error</h1>
    <div v-if="error?.statusCode && error?.statusMessage">
      <div>Status Code: {{ error.statusCode }}</div>
      <div>Message: {{ error.statusMessage }}</div>
    </div>
    <div v-else>
      <h2>An unknown error occurred...</h2>
    </div>
    <button
      class="p-2 bg-gray-500 rounded mt-4 text-white"
      @click="redirectToHome"
    >
      Click here to go back
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  error: Object
})

onMounted(() => {
  console.log(props.error)
})

const redirectToHome = () => clearError({ redirect: "/" })
</script>
